import classNames from 'classnames'
import { useEffect, useState } from 'react'

import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { IFlexItem } from 'core-components/sitebuilder/models/flexGrid/IFlexItem'
import { IFlexLayout } from 'core-components/sitebuilder/models/flexGrid/IFlexLayout'

import { AddWrap } from './flexLayoutSet/AddWrap'
import { FlexLayoutSetCollection } from './flexLayoutSet/helpers/Collection'

interface IFlexLayoutSet {
  settings: IFlexLayout
  width: FlexDirectionBreak
  updateFlexLayout: (newState: IFlexLayout) => void
  className?: string
}

export const getName = () => {
  return `cell-${Math.round(Math.random() * 1000)}`
}

export const FlexLayoutSet = (props: IFlexLayoutSet) => {
  const [id] = useState(Math.floor(Math.random() * 10000))

  const createFlexWrapper = (data: Partial<IFlexItem>): IFlexItem => {
    return {
      widgets: [],
      gap: 0,
      margin: 0,
      isFlexLayout: false,
      canWrap: true,
      size: FlexDirectionBreak.p212,
      name: getName(),
      customWidgetSettings: {},
      systemWidgetSettings: {},
      ...data,
    }
  }

  useEffect(() => {
    const items = props.settings.items || []
    FlexLayoutSetCollection.add(id, [...items])
  }, [id, props.settings])

  useEffect(() => {
    return () => {
      FlexLayoutSetCollection.remove(id)
    }
  }, [id])

  return (
    <>
      <div className={classNames(props.className)}>Wrapper</div>
      <AddWrap
        callback={(whereto) => {
          let items = FlexLayoutSetCollection.get(id)
          if (!items) {
            items = []
            props.updateFlexLayout({
              ...props.settings,
              items: [],
            })
          }
          switch (whereto) {
            case 'left':
              items.unshift(createFlexWrapper({}))
              break
            case 'top':
              items.unshift(createFlexWrapper({ size: props.width }))
              break
            case 'right':
              items.push(createFlexWrapper({}))
              break
            case 'bottom':
              items.push(createFlexWrapper({ size: props.width }))
              break
          }

          props.updateFlexLayout({
            ...props.settings,
            items,
          })
        }}
      />
    </>
  )
}
